module.exports = __webpack_public_path__ + "img/a19.f65bd5ec.svg";